import {
  creationParticipantEligibilityChanged,
  syncCreationParticipantEligibility,
  type ParticipantEligibilityRow,
} from "../eligibility/participantEligibilityRules";

export type { ParticipantEligibilityRow };

export const syncCreationParticipantEligibilityRow =
  syncCreationParticipantEligibility;

export { creationParticipantEligibilityChanged };

export const syncCreationParticipantEligibilityRows = <
  T extends ParticipantEligibilityRow,
>(
  rows: T[],
): T[] => rows.map(syncCreationParticipantEligibility);
